// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ceFX9","fullView":"styles_fullView__2qGgf"};